export enum PreRegistrationStatusCode {
  NotInvited = 0,
  Invited = 1,
  Completed = 2,
  Expired = 3,
}

const PRE_REGISTRATION_STATUS_BY_API_NAME: Record<string, PreRegistrationStatusCode> = {
  notInvited: PreRegistrationStatusCode.NotInvited,
  invited: PreRegistrationStatusCode.Invited,
  completed: PreRegistrationStatusCode.Completed,
  expired: PreRegistrationStatusCode.Expired,
};

export function parsePreRegistrationStatus(value: unknown): number | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return undefined;
    }
    const asNum = Number(trimmed);
    if (Number.isFinite(asNum)) {
      return asNum;
    }
    const key = trimmed.replace(/\s+/g, '').toLowerCase();
    const mapped = PRE_REGISTRATION_STATUS_BY_API_NAME[key];
    if (mapped !== undefined) {
      return mapped;
    }
  }
  return undefined;
}

export function getPreRegistrationStatusShortLabel(code: number): string {
  switch (code) {
    case PreRegistrationStatusCode.Invited:
      return 'Pré-Cadastro pendente';
    case PreRegistrationStatusCode.Completed:
      return 'Pré-Cadastro concluído';
    case PreRegistrationStatusCode.Expired:
      return 'Prazo expirado';
    default:
      return '';
  }
}

export function getPreRegistrationStatusTooltip(code: number, expirationIso?: string | null): string {
  const base = getPreRegistrationStatusDetailText(code);
  if (!expirationIso || !shouldShowExpirationHint(code)) {
    return base;
  }
  const formatted = formatPreRegistrationDeadline(expirationIso);
  if (!formatted) {
    return base;
  }
  return `${base} Prazo do link: ${formatted}.`;
}

function shouldShowExpirationHint(code: number): boolean {
  return (
    code === PreRegistrationStatusCode.Invited ||
    code === PreRegistrationStatusCode.Expired
  );
}

function getPreRegistrationStatusDetailText(code: number): string {
  switch (code) {
    case PreRegistrationStatusCode.Invited:
      return 'Link de pré-cadastro enviado; aguardando o candidato enviar o formulário.';
    case PreRegistrationStatusCode.Completed:
      return 'Pré-cadastro de admissão concluído pelo candidato.';
    case PreRegistrationStatusCode.Expired:
      return 'O prazo do link de pré-cadastro de admissão expirou.';
    default:
      return '';
  }
}

function formatPreRegistrationDeadline(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getPreRegistrationBadgeCssClass(code: number): string {
  switch (code) {
    case PreRegistrationStatusCode.Invited:
      return 'pre-registration-invited';
    case PreRegistrationStatusCode.Completed:
      return 'pre-registration-completed';
    case PreRegistrationStatusCode.Expired:
      return 'pre-registration-expired';
    default:
      return '';
  }
}
